


















































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop()
  private type: any;
  private readImg(url: any) {
    window.open(url);
  }
  private tree: any = [
    {
      isHeader: true,
      children: [
        {
          type: "text",
          name: "黑睛",
          colspan: 2,
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "颜色",
          colspan: 2,
          part: "黑睛",
          key1: "color",
          key2: "color",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "质地",
          part: "黑睛",
          key1: "质地",
          key2: "质地",
          colspan: 2,
        },
      ],
    },
    {
      children: [
        {
          name: "坑洞",
          rowspan: 2,
        },
        {
          type: "单选",
          name: "坑洞",
          part: "黑睛",
          key1: "坑洞",
          key2: "坑洞",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "位置",
          part: "黑睛",
          key1: "坑洞",
          key2: "位置",
        },
      ],
    },
    {
      children: [
        {
          name: "辐射状黑线",
          rowspan: 2,
        },
        {
          type: "单选",
          name: "辐射状黑线",
          part: "黑睛",
          key1: "辐射状黑线",
          key2: "辐射状黑线",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "位置",
          part: "黑睛",
          key1: "辐射状黑线",
          key2: "位置",
        },
      ],
    },
    {
      children: [
        {
          name: "同心圆状白线",
          rowspan: 3,
        },
        {
          type: "单选",
          name: "同心圆状白线",
          part: "黑睛",
          key1: "同心圆状白线",
          key2: "同心圆状白线",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "局部",
          part: "黑睛",
          key1: "同心圆状白线",
          key2: "局部",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "全部",
          part: "黑睛",
          key1: "同心圆状白线",
          key2: "全部",
        },
      ],
    },
    {
      children: [
        {
          name: "黑斑黑点",
          rowspan: 2,
        },
        {
          type: "单选",
          name: "黑斑黑点",
          part: "黑睛",
          key1: "黑斑黑点",
          key2: "黑斑黑点",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "位置",
          part: "黑睛",
          key1: "黑斑黑点",
          key2: "位置",
        },
      ],
    },
    {
      children: [
        {
          name: "黑睛七环",
          rowspan: 4,
        },
        {
          type: "多选",
          name: "代谢环(环一)",
          part: "黑睛",
          key1: "黑睛七环",
          key2: "代谢环",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "肠道环(环二、环三)",
          part: "黑睛",
          key1: "黑睛七环",
          key2: "肠道环",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "环七",
          part: "黑睛",
          key1: "黑睛七环",
          key2: "环七",
        },
      ],
    },
    {
      children: [
        {
          type: "标注",
          name: "标注",
          subName: "环四",
          unit: "px²",
          part: "轨迹",
          key1: "黑睛",
        },
      ],
    },
    {
      isHeader: true,
      children: [
        {
          type: "text",
          name: "白睛脉络",
          colspan: 2,
        },
      ],
    },
    {
      children: [
        {
          name: "白睛脉络上",
          rowspan: 5,
        },
        {
          type: "多选",
          name: "颜色",
          part: "白睛脉络",
          key1: "上",
          key2: "color",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "形状",
          part: "白睛脉络",
          key1: "上",
          key2: "形状",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "走行",
          part: "白睛脉络",
          key1: "上",
          key2: "走行",
        },
      ],
    },
    {
      children: [
        {
          type: "诊断评分",
          name: "诊断评分",
          part: "白睛脉络",
          key1: "上",
          key2: "诊断评分",
        },
      ],
    },
    {
      children: [
        {
          type: "标注",
          name: "标注",
          subName: "最突出脉络",
          unit: "px²",
          part: "轨迹",
          key1: "上",
        },
      ],
    },
    {
      children: [
        {
          name: "白睛脉络下",
          rowspan: 5,
        },
        {
          type: "多选",
          name: "颜色",
          part: "白睛脉络",
          key1: "下",
          key2: "color",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "形状",
          part: "白睛脉络",
          key1: "下",
          key2: "形状",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "走行",
          part: "白睛脉络",
          key1: "下",
          key2: "走行",
        },
      ],
    },
    {
      children: [
        {
          type: "诊断评分",
          name: "诊断评分",
          part: "白睛脉络",
          key1: "下",
          key2: "诊断评分",
        },
      ],
    },
    {
      children: [
        {
          type: "标注",
          name: "标注",
          subName: "最突出脉络",
          unit: "px²",
          part: "轨迹",
          key1: "下",
        },
      ],
    },
    {
      children: [
        {
          name: "白睛脉络左",
          rowspan: 5,
        },
        {
          type: "多选",
          name: "颜色",
          part: "白睛脉络",
          key1: "左",
          key2: "color",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "形状",
          part: "白睛脉络",
          key1: "左",
          key2: "形状",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "走行",
          part: "白睛脉络",
          key1: "左",
          key2: "走行",
        },
      ],
    },
    {
      children: [
        {
          type: "诊断评分",
          name: "诊断评分",
          part: "白睛脉络",
          key1: "左",
          key2: "诊断评分",
        },
      ],
    },
    {
      children: [
        {
          type: "标注",
          name: "标注",
          subName: "最突出脉络",
          unit: "px²",
          part: "轨迹",
          key1: "左",
        },
      ],
    },
    {
      children: [
        {
          name: "白睛脉络右",
          rowspan: 5,
        },
        {
          type: "多选",
          name: "颜色",
          part: "白睛脉络",
          key1: "右",
          key2: "color",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "形状",
          part: "白睛脉络",
          key1: "右",
          key2: "形状",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "走行",
          part: "白睛脉络",
          key1: "右",
          key2: "走行",
        },
      ],
    },
    {
      children: [
        {
          type: "诊断评分",
          name: "诊断评分",
          part: "白睛脉络",
          key1: "右",
          key2: "诊断评分",
        },
      ],
    },
    {
      children: [
        {
          type: "标注",
          name: "标注",
          subName: "最突出脉络",
          unit: "px²",
          part: "轨迹",
          key1: "右",
        },
      ],
    },
    {
      children: [
        {
          name: "白睛脉络左上",
          rowspan: 5,
        },
        {
          type: "多选",
          name: "颜色",
          part: "白睛脉络",
          key1: "左上",
          key2: "color",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "形状",
          part: "白睛脉络",
          key1: "左上",
          key2: "形状",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "走行",
          part: "白睛脉络",
          key1: "左上",
          key2: "走行",
        },
      ],
    },
    {
      children: [
        {
          type: "诊断评分",
          name: "诊断评分",
          part: "白睛脉络",
          key1: "左上",
          key2: "诊断评分",
        },
      ],
    },
    {
      children: [
        {
          type: "标注",
          name: "标注",
          subName: "最突出脉络",
          unit: "px²",
          part: "轨迹",
          key1: "左上",
        },
      ],
    },
    {
      children: [
        {
          name: "白睛脉络左下",
          rowspan: 5,
        },
        {
          type: "多选",
          name: "颜色",
          part: "白睛脉络",
          key1: "左下",
          key2: "color",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "形状",
          part: "白睛脉络",
          key1: "左下",
          key2: "形状",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "走行",
          part: "白睛脉络",
          key1: "左下",
          key2: "走行",
        },
      ],
    },
    {
      children: [
        {
          type: "诊断评分",
          name: "诊断评分",
          part: "白睛脉络",
          key1: "左下",
          key2: "诊断评分",
        },
      ],
    },
    {
      children: [
        {
          type: "标注",
          name: "标注",
          subName: "最突出脉络",
          unit: "px²",
          part: "轨迹",
          key1: "左下",
        },
      ],
    },
    {
      children: [
        {
          name: "白睛脉络右上",
          rowspan: 5,
        },
        {
          type: "多选",
          name: "颜色",
          part: "白睛脉络",
          key1: "右上",
          key2: "color",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "形状",
          part: "白睛脉络",
          key1: "右上",
          key2: "形状",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "走行",
          part: "白睛脉络",
          key1: "右上",
          key2: "走行",
        },
      ],
    },
    {
      children: [
        {
          type: "诊断评分",
          name: "诊断评分",
          part: "白睛脉络",
          key1: "右上",
          key2: "诊断评分",
        },
      ],
    },
    {
      children: [
        {
          type: "标注",
          name: "标注",
          subName: "最突出脉络",
          unit: "px²",
          part: "轨迹",
          key1: "右上",
        },
      ],
    },
    {
      children: [
        {
          name: "白睛脉络右下",
          rowspan: 5,
        },
        {
          type: "多选",
          name: "颜色",
          part: "白睛脉络",
          key1: "右下",
          key2: "color",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "形状",
          part: "白睛脉络",
          key1: "右下",
          key2: "形状",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "走行",
          part: "白睛脉络",
          key1: "右下",
          key2: "走行",
        },
      ],
    },
    {
      children: [
        {
          type: "诊断评分",
          name: "诊断评分",
          part: "白睛脉络",
          key1: "右下",
          key2: "诊断评分",
        },
      ],
    },
    {
      children: [
        {
          type: "标注",
          name: "标注",
          subName: "最突出脉络",
          unit: "px²",
          part: "轨迹",
          key1: "右下",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          name: "特殊眼征",
          colspan: 2,
          part: "白睛脉络",
          key1: "特殊眼征",
          key2: "特殊眼征",
        },
      ],
    },
    {
      isHeader: true,
      children: [
        {
          type: "text",
          name: "综合建议",
          colspan: 2,
        },
      ],
    },
    {
      children: [
        {
          name: "按诊断分",
          rowspan: 5,
        },
        {
          type: "多选",
          contentType: "名称",
          name: "西医疾病",
          part: "专家建议",
          key1: "按诊断分",
          key2: "西医疾病",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          contentType: "名称",
          name: "中医疾病",
          label: "民族医疾病",
          part: "专家建议",
          key1: "按诊断分",
          key2: "中医疾病",
        },
      ],
    },
    {
      children: [
        {
          type: "多选",
          contentType: "名称",
          name: "中医证型",
          label: "民族医证型",
          part: "专家建议",
          key1: "按诊断分",
          key2: "中医证型",
        },
      ],
    },
    {
      children: [
        {
          type: "单选",
          name: "疾病分型",
          part: "专家建议",
          key1: "按诊断分",
          key2: "疾病分型",
        },
      ],
    },
    {
      children: [
        {
          type: "单选",
          name: "病程",
          part: "专家建议",
          key1: "按诊断分",
          key2: "病程",
        },
      ],
    },
    {
      children: [
        {
          type: "建议",
          name: "综合分析",
          part: "专家建议",
          key1: "专家建议",
          colspan: 2,
        },
      ],
    },
  ];
  /**
   * @description 获取需要显示的数据
   */
  private getValue(item: any, position: any, author: any) {
    let str: any = "";
    if (item.type == "标注") {
      let imgs: any = [];
      if (position == "left_eye") {
        imgs = this.data[author].l_eye_image;
      } else if (position == "right_eye") {
        imgs = this.data[author].r_eye_image;
      }
      let d: any = [];
      if (
        this.data[author] &&
        this.data[author][item.part] &&
        this.data[author][item.part][item.key1]
      ) {
        d = this.data[author][item.part][item.key1];
      }
      if (d.length > 0) {
        imgs.forEach((ele: any) => {
          const index: any = d.findIndex((val: any) => {
            return val.id == ele;
          });
          if (index !== -1) {
            str = item.subName + "(" + d[index].data.area.toFixed(2) + "px²)";
          }
        });
      }
    } else if (item.type == "诊断评分") {
      if (
        this.data[author] &&
        this.data[author][position] &&
        this.data[author][position][item.part] &&
        this.data[author][position][item.part][item.key1] &&
        this.data[author][position][item.part][item.key1][item.key2] &&
        this.data[author][position][item.part][item.key1][item.key2].total_score
      ) {
        const value: any =
          this.data[author][position][item.part][item.key1][item.key2]
            .total_score;
        str = value + "分";
      }
    } else if (item.type == "建议") {
      if (
        this.data[author] &&
        this.data[author][position] &&
        this.data[author][position][item.part] &&
        this.data[author][position][item.part][item.key1]
      ) {
        const value: any = this.data[author][position][item.part][item.key1];
        str = value;
      }
    } else {
      if (
        this.data[author] &&
        this.data[author][position] &&
        this.data[author][position][item.part] &&
        this.data[author][position][item.part][item.key1] &&
        this.data[author][position][item.part][item.key1][item.key2] &&
        this.data[author][position][item.part][item.key1][item.key2].length > 0
      ) {
        const value: any =
          this.data[author][position][item.part][item.key1][item.key2];
        if (value && value.length > 0 && item.type == "多选") {
          if (item.contentType) {
            // 是obj数组
            str = "";
            value.forEach((obj: any, objIndex: any) => {
              if (objIndex !== 0) {
                str += "、";
              }
              str += obj[item.contentType];
            });
          } else {
            str = value.join("、");
          }
        } else if (value && item.type == "单选") {
          str = value;
        } else {
          str = "";
        }
      }
    }
    return str;
  }
  /**
   * @description 判断学生和教师的答案是否一致
   */
  private ifIdentical(item: any, position: any) {
    let student: any;
    let teacher: any;
    let result: any = true;
    if (item.type == "多选") {
      student = [];
      teacher = [];
    } else {
      student = "";
      teacher = "";
    }
    if (item.type == "标注") {
      let imgs: any = [];
      if (position == "left_eye") {
        imgs = this.data["student"].l_eye_image;
      } else if (position == "right_eye") {
        imgs = this.data["student"].r_eye_image;
      }
      let d: any = [];
      let d2: any = [];
      if (
        this.data["student"] &&
        this.data["student"][item.part] &&
        this.data["student"][item.part][item.key1]
      ) {
        d = this.data["student"][item.part][item.key1];
      }
      if (d.length > 0) {
        imgs.forEach((ele: any) => {
          const index: any = d.findIndex((val: any) => {
            return val.id == ele;
          });
          if (index !== -1) {
            student = d[index].data.area.toFixed(2);
          }
        });
      }
      if (
        this.data["teacher"] &&
        this.data["teacher"][item.part] &&
        this.data["teacher"][item.part][item.key1]
      ) {
        d2 = this.data["teacher"][item.part][item.key1];
      }
      if (d2.length > 0) {
        imgs.forEach((e: any) => {
          const index: any = d2.findIndex((val: any) => {
            return val.id == e;
          });
          if (index !== -1) {
            teacher = d2[index].data.area.toFixed(2);
          }
        });
      }
      result = student == teacher ? true : false;
    } else if (item.type == "诊断评分") {
      if (
        this.data["student"] &&
        this.data["student"][position] &&
        this.data["student"][position][item.part] &&
        this.data["student"][position][item.part][item.key1] &&
        this.data["student"][position][item.part][item.key1][item.key2] &&
        this.data["student"][position][item.part][item.key1][item.key2]
          .total_score
      ) {
        student =
          this.data["student"][position][item.part][item.key1][item.key2]
            .total_score;
      }
      if (
        this.data["teacher"] &&
        this.data["teacher"][position] &&
        this.data["teacher"][position][item.part] &&
        this.data["teacher"][position][item.part][item.key1] &&
        this.data["teacher"][position][item.part][item.key1][item.key2] &&
        this.data["teacher"][position][item.part][item.key1][item.key2]
          .total_score
      ) {
        teacher =
          this.data["teacher"][position][item.part][item.key1][item.key2]
            .total_score;
      }
      result = student == teacher ? true : false;
    } else if (item.type == "建议") {
      let student: any = "";
      let teacher: any = "";
      if (
        this.data["student"] &&
        this.data["student"][position] &&
        this.data["student"][position][item.part] &&
        this.data["student"][position][item.part][item.key1]
      ) {
        student = this.data["student"][position][item.part][item.key1];
      }
      if (
        this.data["teacher"] &&
        this.data["teacher"][position] &&
        this.data["teacher"][position][item.part] &&
        this.data["teacher"][position][item.part][item.key1]
      ) {
        teacher = this.data["teacher"][position][item.part][item.key1];
      }
      result = student == teacher ? true : false;
    } else {
      if (
        this.data.student &&
        this.data.student[position] &&
        this.data.student[position][item.part] &&
        this.data.student[position][item.part][item.key1] &&
        this.data.student[position][item.part][item.key1][item.key2] &&
        this.data.student[position][item.part][item.key1][item.key2].length > 0
      ) {
        student = JSON.parse(
          JSON.stringify(
            this.data.student[position][item.part][item.key1][item.key2]
          )
        );
      }
      if (
        this.data.teacher &&
        this.data.teacher[position] &&
        this.data.teacher[position][item.part] &&
        this.data.teacher[position][item.part][item.key1] &&
        this.data.teacher[position][item.part][item.key1][item.key2] &&
        this.data.teacher[position][item.part][item.key1][item.key2].length > 0
      ) {
        teacher = JSON.parse(
          JSON.stringify(
            this.data.teacher[position][item.part][item.key1][item.key2]
          )
        );
      }
      // 判断是否重复
      if (item.type == "单选") {
        result = student == teacher ? true : false;
      } else if (item.type == "多选") {
        // 首先确保两个数组都是数组类型
        if (!Array.isArray(student) || !Array.isArray(teacher)) {
          result = false;
        } else if (student.length !== teacher.length) {
          // 检查两个数组的长度是否相等
          result = false;
        }
        // 对两个数组进行排序
        if (student.length > 0) {
          student.sort();
        }
        if (teacher.length > 0) {
          teacher.sort();
        }

        // 比较排序后的数组元素
        let studentArr: any = "";
        let teachertArr: any = "";
        if (item.contentType) {
          // 是obj数组
          student.forEach((obj: any, objIndex: any) => {
            if (objIndex !== 0) {
              studentArr += "、";
            }
            studentArr += obj[item.contentType];
          });
          teacher.forEach((obj: any, objIndex: any) => {
            if (objIndex !== 0) {
              teachertArr += "、";
            }
            teachertArr += obj[item.contentType];
          });
        } else {
          studentArr = student.join("、");
          teachertArr = teacher.join("、");
        }
        result = studentArr == teachertArr ? true : false;
      }
    }

    return result;
  }
  private mounted() {}
}
